import React, {
  RefObject,
} from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
  EditableRendererProps,
} from 'core/components/VirtualTable/types';
import DatePicker from 'core/components/DateTimePicker/SingleDatePicker';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import {
  Dayjs,
} from 'utils/dayjs';

function EditableDatePicker({
  value,
  controlRef,
  props = {},
  onChange,
}: EditableRendererProps<Dayjs | undefined>) {
  return (
    <DatePicker
      {...props}
      inputRef={controlRef as RefObject<HTMLInputElement>}
      value={value}
      onChange={(val) => {
        if (!(value?.isValid() && val?.isValid() && value.isSame(val, 'day'))) {
          onChange?.(val ?? undefined);
        }
      }}
      showDateButtons={false}
      disableFuture
    />
  );
}

const editableMeta = {
  editable: {
    Component: EditableDatePicker,
    alwaysEditable: true,
    mode: 'onChange',
  },
};

export default {
  id: 'serviceDate',
  accessorFn: (row: VisitNoteServiceCode) => row?.serviceCodeDetails?.serviceDate,
  columnTitle: (
    <>
      Service
      <br />
      Date
    </>
  ),
  meta: editableMeta,
  size: 140,
  minSize: 120,
} as ColumnDef<VisitNoteServiceCode>;
